/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ClientBridge } from "./ClientBridge";

export class ClientBridgeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ClientBridge> {
    return super.deploy(overrides || {}) as Promise<ClientBridge>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ClientBridge {
    return super.attach(address) as ClientBridge;
  }
  connect(signer: Signer): ClientBridgeFactory {
    return super.connect(signer) as ClientBridgeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ClientBridge {
    return new Contract(address, _abi, signerOrProvider) as ClientBridge;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bridge",
        type: "address",
      },
    ],
    name: "BridgeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "mediator",
        type: "address",
      },
    ],
    name: "MultiTokenMediatorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Relayed",
    type: "event",
  },
  {
    inputs: [],
    name: "ambBridge",
    outputs: [
      {
        internalType: "contract IAMB",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "erc20Transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAMB",
        name: "_ambBridge",
        type: "address",
      },
      {
        internalType: "contract IMultiTokenMediator",
        name: "_multiTokenMediator",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "multiTokenMediator",
    outputs: [
      {
        internalType: "contract IMultiTokenMediator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAMB",
        name: "_ambBridge",
        type: "address",
      },
    ],
    name: "setAMBBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IMultiTokenMediator",
        name: "_multiTokenMediator",
        type: "address",
      },
    ],
    name: "setMultiTokenMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "trustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
